import React from 'react';
import { useEffect, useState, useRef } from "react";
import NavButton from '../../homepage/header-banner/TopNavButton';
import ServerPricing from '../../homepage/header-banner/ServerPricing';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import Sidebar from '../../container/Sidebar/Sidebar'
// import '../../container/Sidebar/sidebar.css'
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute"
import Contentcloudcard from "../../container/Card/Components/Contentcloudcard"
import Imagecloudcompute from "../../container/Card/Components/Imagecloudcompute"
import CardBoxRow from '../../container/Box/Components/CardBox-Row'
import CommonTable from '../../container/Table/Components/CommonTable';
import CloudConsultCp from '../../homepage/consult/cloudconsult-cp';
import '../../Style/typo.css'
import Cloudconsult2 from '../../homepage/consult/cloudconsult-2';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import DividerComponent from '../../container/Divider/divider';
import styled from 'styled-components';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-vn';
import Cloudconsult2VN from '../../homepage/consult/cloudconsult-2-vn';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import HeaderVn from '../../detailpageVN/Page/component/headervn';
import FooterVn from '../../detailpageVN/Page/component/footervn';

const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;

// Titlecloudcompute
function MonitoringVolumeVN() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = 'Cấu trúc Monitoring • Volume - Private Kubernetes - Private Cloud';
    }, []);
    return (
        <Sysfont className='App'>
            <HeaderVn />
            <BannerPrivateCloudVN />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarVN />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("모니터링•볼륨 구조")} */}
                        {/* {Contentcloudcard("고성능 Local SSD replication Volume 적용 안정적인 서비스운영","모든 인스턴스에 물리적인 rCPU (1배수) 적용, 고용량의 메모리제공")} */}
                        <MuiGrid container spacing={3}>
                            <MuiGrid item xs={12} sm={12} className='Grid-card'>{CardBoxRow(
                                "<p class='typo-21-sm typo-medium typo-black'>Cấu trúc giám sát (Monitoring) của Kubernetes riêng tư</p>",

                                `
                                <p class='typo-14'>Hệ thống giám sát của Kubernetes riêng tư cung cấp khả năng theo dõi trạng thái các pod trong thời gian thực, giúp phát hiện và xử lý sự cố nhanh chóng.</p>
                                
                                <p class='typo-14'>Dữ liệu thu thập từ Monitoring Pod sẽ được lưu trữ trong Hanbit Object Storage trong một khoảng thời gian nhất định, từ đó tạo ra các log và chỉ số để phân tích.</p>
                                
                                <p class='typo-14'>Hệ thống gửi thông báo qua Push, Email hoặc các phương thức khác khi có sự cố, giúp các kỹ sư có thể phản ứng kịp thời.</p>

                                `)}</MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} className='Grid-card'>{Imagecloudcompute("https://hanbiro.com/assets/images/cloud/en/back-office-2.png")}</MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12} className='Grid-card'>{CardBoxRow(
                                "Vận hành Persistent Volume trong Kubernetes riêng tư",

                                `
                                <p class='typo-14'>Kubernetes riêng tư sử dụng Local Volume làm cấu hình cơ bản để quản lý Persistent Volume.</p>
                                
                                <p class='typo-14'>Bằng cách nhận diện volume thông qua openEBS hoặc HostPath, hệ thống có thể tạo ra các volumes với hiệu suất cao, phù hợp cho nhu cầu lưu trữ và xử lý dữ liệu lớn.</p>
                                
                                <p class='typo-14'>Giải pháp này hỗ trợ mở rộng liên tục và tối ưu cho các ứng dụng streaming, giúp đảm bảo hiệu năng ổn định và khả năng mở rộng linh hoạt.</p>
                                `)}</MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} className='Grid-card'>{Imagecloudcompute("https://hanbiro.com/assets/images/cloud/en/persistant-volume-operation.png")}</MuiGrid>
                            <DividerComponent />
                        </MuiGrid>
                        <Cloudconsult2VN />
                    </Col>
                </Row>
            </Container>


            <FooterVn />
        </Sysfont>
    );
};

const MuiGrid = styled.div`
    padding: 0px,
`

export default MonitoringVolumeVN;